import React from 'react'
import ShowChartIcon from '@material-ui/icons/ShowChartOutlined'
import { createColumnInstance } from '../../constants'

const NET_CASHFLOW_TYPES = [
  'Contributions',
  'Distributions',
  'NetDividendsInterestGainsWithdrawn',
  'Merge In',
  'Merge Out',
  'Journal In',
  'Journal Out'
]

const MV = createColumnInstance('marketValue')
const ACTIVITY = createColumnInstance('activity', { activityTypes: NET_CASHFLOW_TYPES })

export const mvVsNetAdditions = Object.freeze({
  id: 'mv-vs-net-additions',
  name: 'Market Value vs Net Additions',
  description: 'Market Value overlaid with cumulative net additions over time.',
  renderIcon: () => <ShowChartIcon style={{ fontSize: 16 }} />,
  toolId: 'trend',
  resolve: () => ({
    ok: true,
    payload: {
      scope: 'level',
      columnInstance: MV,
      compareColumns: [ACTIVITY],
      chartType: 'line',
      frequency: 'Automatic'
    }
  })
})
